<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zS9DqC/tc-custom/9781685506766.jpg?1723404599035" alt="This image is the cover for the book Realignment"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Realignment
      </h1>
      <p class="bookDescription body article font2">
        <p>Blake Truman has come to Sunridge looking for his ex. Finally out of jail and rehab, Blake is ready to start over, this time without the drugs. However, when he finds Lee in the arms of a new man, he knows it's time to get out of town and move on. Which he would do, gladly, if he hadn't wound up on the wrong end of a rifle while stealing some gas.<br/><br/>Connor Riley has been struggling to keep up with his farm on his own. With the passing of his wife, and Scott leaving home to start his own business, things are tough. He decides to take Blake showing up on his property as an opportunity. Just because Blake has an ugly past, that doesn't mean he can't lift a shovel or sling some hay.<br/><br/>As they get closer, neither age difference nor past loves can stand in the way of a blossoming attraction. Connor's son Scott might though, as soon as Scott finds out his dad's new right hand man is also the man that Scott believes ruined his lover's life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.F. Henley
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?08243f25